import Api from '@/services/Api';

export default {
  getServers(game) {
    return Api().get(`chatlogs/${game}/servers`);
  },
  getLogs(game, server, page, clientId, order) {
    const search = game === 'q3' ? { clientId } : { steamid: clientId };
    return Api().get(`chatlogs/${game}/${server}`, {
      params: {
        page,
        order,
        ...search,
      },
    });
  },
};
